import { ChevronDown } from "lucide-react";
import { Button } from "./ui/button";
import coin from "../assets/images/placeholder/crypto-colour.png";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import PairSelectionContent from "./PairSelectionContent";

interface TradingPair {
  id: string;
  pair: string;
  asset: string;
  assetIcon?: string;
  assetName?: string;
  type?: string;
  formattedAvailableAmount?: string;
  [key: string]: unknown;
}

interface Asset {
  assetId: string;
  asset: string;
  [key: string]: unknown;
}

interface PairSelectionDropdownProps {
  selectedPair: TradingPair | null;
  selectedAsset: Asset | null | undefined;
  currentPairs: TradingPair[] | null | undefined;
  onPairSelect: (pair: TradingPair) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  emptyStateMessage?: string;
  loadingMessage?: string;
}

export default function PairSelectionDropdown({
  selectedPair,
  selectedAsset,
  currentPairs,
  onPairSelect,
  open,
  onOpenChange,
  emptyStateMessage,
  loadingMessage,
}: PairSelectionDropdownProps) {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange} modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="w-full flex items-center justify-between py-8 rounded-2xl hover:border-brand-primary transition-colors h-[70px] md:h-[88px]"
        >
          <div className="flex items-center gap-3">
            <div className="w-8 md:w-10 h-8 md:h-10 rounded-full flex items-center justify-center">
              {selectedPair ? (
                <img
                  src={selectedPair.assetIcon}
                  alt={selectedPair.assetName}
                  width={32}
                  height={32}
                  className="text-white max-w-full h-auto"
                />
              ) : (
                <img
                  src={coin}
                  alt={"Default Asset"}
                  width={32}
                  height={32}
                  className="text-white max-w-full h-auto"
                />
              )}
            </div>
            <div className="text-left">
              <div className="font-semibold">
                {selectedPair?.asset.toUpperCase()}
              </div>
              {!selectedPair?.assetName && (
                <div className="font-semibold text-sm md:text-base">
                  Select...
                </div>
              )}
            </div>
          </div>
          <ChevronDown className="text-gray-400 w-4 h-4 md:w-5 md:h-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="rounded-2xl p-6"
        align="start"
        style={{ width: "var(--radix-dropdown-menu-trigger-width)" }}
      >
        <PairSelectionContent
          selectedAsset={selectedAsset}
          currentPairs={currentPairs}
          onPairSelect={onPairSelect}
          emptyStateMessage={emptyStateMessage}
          loadingMessage={loadingMessage}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
